export const NO_MSB = 'no_msb';
export const MSB_PENDING = 'pending';
export const MSB_FINISHED = 'finished';
